import { render, staticRenderFns } from "./regularizar_inventario.vue?vue&type=template&id=1fea4e1a&"
import script from "./regularizar_inventario.vue?vue&type=script&lang=js&"
export * from "./regularizar_inventario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports